export const FETCH_USER = 'FETCH_USER';
export const FILTER_USER = 'FILTER_USER';